// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"bc28d989","889":"d6d17694"}[chunkId] + ".chunk.js";
};